import { render, staticRenderFns } from "./motivateAdd.vue?vue&type=template&id=3db063dc&scoped=true&"
import script from "./motivateAdd.vue?vue&type=script&lang=js&"
export * from "./motivateAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db063dc",
  null
  
)

export default component.exports